@if (selectedMenuArea() && menuAreas()?.length > 1) {
  <mat-select
    class="area-dropdown"
    [class]="{ 'narrow-dropdown': !isWide() }"
    panelClass="main-menu-area-panel"
    [panelWidth]="null"
    [ngModel]="selectedMenuArea()"
    (selectionChange)="areaChanged.emit($event.value?.id)">
    <mat-select-trigger>
      <app-menu-item [ignoreWidgetEvents]="true"
        [name]="selectedMenuArea().name"
        [shortLabel]="selectedMenuArea().shortLabel"
        [label]="selectedMenuArea().label"
        [isWide]="isWide()"
        [icon]="selectedMenuArea().icon" />
    </mat-select-trigger>
    @for (menuArea of menuAreas(); track menuArea.id) {
      <mat-option [value]="menuArea">
        <app-menu-item [ignoreWidgetEvents]="true"
          [name]="menuArea.name"
          [shortLabel]="menuArea.shortLabel"
          [label]="menuArea.label"
          [isWide]="true"
          [icon]="menuArea.icon" />
      </mat-option>
    }
  </mat-select>
}
